/* tslint:disable */

/**
 */
export class Folder {
    id?: number;
    name?: string;
}
